var Events = $.extend(false, BaseModule ,{

    api_route : 'events',

	data : {
		module      : 'events',
		page        : 1,
		limit       : 42,
        details_with: 'file:products',
        view        : 'grid',
        pagination  : true
	},
    commit : function(){
        var module_name = this.data.module,
            all_component_data = [],
            $form = $('form[name="'+module_name+'_form"]');

        $form.find('.content-editable').each(function(){

            var name = $(this).data('name').split('.'),

                component_data = $(this).closest('.article-component').data('component');

            if( typeof(component_data.data) == 'undefined' || component_data.data.length  ==0  ){
                component_data.data = {};
            }
            component_data.data[ String(name[0]) ] = $(this).html();
            if(component_data.data[ String(name[0]) ] == ''){
                component_data.data[ String(name[0]) ] = $(this).val();
            }
            $(this).closest('.article-component').data('component' , component_data);

        });


        $form.find('.article-component').each(function(){
            var component = $(this);

            if(component.data('component')){
                component_data =  $(this).data('component');

                if(component.data('key')){
                    component_data['data'] = {};
                    component_data['data']['images'] = [];
                    component_data['data']['images_crops'] = [];
                    component_data['data']['images_uploads'] = [];

                    component.find('input[data-name="' + component.data('key')+'"]').each(function(){
                        var vv = $(this).val();
                        component_data['data']['images'].push(vv);
                    });
                    component.find('input[data-name="' + component.data('key')+'_crop"]').each(function(){
                        var vv = $(this).val();
                        component_data['data']['images_crops'].push(vv);
                    });
                    component.find('input[data-name="' + component.data('key')+'_uploader_filename"]').each(function(){
                        var vv = $(this).val();
                        component_data['data']['images_uploads'].push(vv);
                    });
                }
                all_component_data.push(component_data);
            }

        });

        $form.find('input[name="components"]').val(JSON.stringify(all_component_data));
    },

    before_save:function(){
        var module_name = this.data.module;
        Builder.set_target($('form[name="'+module_name+'_form"]')).commit();
    },

    after_load_entry:function(){
        "use strict";
        var module = this;
        var module_name = this.data.module;

        module.save();
        Builder.set_target($('form[name="'+module_name+'_form"]')).setup();

        $('#events_form .update-map').click(function () {
            var address = $('input[name="address"]').val();
            module.geocode(address);
            return false;

        });

        if($('#events_form input[name="latitude"]')){
            module.init_map($('#events_form input[name="latitude"]').val(), $('#events_form input[name="longitude"]').val());
        }

    },

    init_map : function(lat,lng){

        $('#events_form input[name="latitude"]').removeClass('empty').val(lat);
        $('#events_form input[name="longitude"]').removeClass('empty').val(lng);

        var latLng = new google.maps.LatLng(lat, lng);
        var map = new google.maps.Map(document.getElementById('mapCanvas'), {
            zoom: 17,
            center: latLng,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        var marker = new google.maps.Marker({
            position: latLng,
            title: 'Location',
            map: map,
            draggable: true
        });

        google.maps.event.addListener(marker, 'dragend', function () {
            var newPosition = marker.getPosition();
            $('#events_form input[name="latitude"]').val(newPosition.lat());
            $('#events_form input[name="longitude"]').val(newPosition.lng());
            $('#events_form .update-map span').html('Reset Map');
        });
    },

    geocode : function(address){
        var module  = this;
        var geocoder = new google.maps.Geocoder();
        address = address.replace(/\n/g, ',').replace(/\s/g, ' ').replace(/  ,/g, ',');

        geocoder.geocode({
            'address': address}, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                var lat = results[0].geometry.location.lat();
                var lng = results[0].geometry.location.lng();

                module.init_map(lat, lng);

            } else {
                alert("We couldn't find a valid Location based on the given address");
            }
        });

    },

    init:function(){
        var module_name = this.data.module,  module = this;
    }
});

$(document).ready(function(){
    "use strict";
    Events.init();

});
